import React from 'react';
import NI_open_poster from '../../assets/Images/NIOpenPoster.jpg';
import Sponsors from '../../assets/Images/Sponsors.jpeg';
import './NIOpen.css';

function NIOpen() {
  return (
    <div>
      <h1>The NIKB Northern Ireland Open 2026</h1>
      <div className='sideBySide'>
        <div className='NIOpenPosterContainer'>
          <img src={NI_open_poster} className="ni_open_poster" alt="NIKB NI Open poster" />
        </div>
        <div className='NIOpenSponsorsContainer'>
          <h2>Thank You To Our Sponsors!</h2>
          <img src={Sponsors} className="sponsors" alt="NIKB NI Open sponsors" />
          <p>Check out our images from the event <a href="https://drive.google.com/drive/folders/1urVtgK4jxoAwfvocRUA4pIO1S7Gbgc6l?fbclid=IwY2xjawRd1OZleHRuA2FlbQIxMABzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeRhKoSslTYLyWMfuM0gbcq2T1VSklnxrvWVhJ7rPkxQY_XtoJT2lZsxn4aZk_aem_WB9mapvcPjIWDS7gpjgIog">here</a>!</p>
        </div>
      </div>
    </div>
  );
}

export default NIOpen;
